var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardDropdownClose = function SvgNewcsDashboardDropdownClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.996,
    height: 7.996
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.209 3.989 2.529-2.487A.867.867 0 0 0 6.521.266L3.992 2.752 1.539.259A.867.867 0 0 0 .302 1.475l2.454 2.494-2.5 2.457a.868.868 0 0 0 1.218 1.236l2.5-2.457 2.49 2.532A.868.868 0 0 0 7.701 6.52Z",
    opacity: 0.8
  })));
};
export default SvgNewcsDashboardDropdownClose;